import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FinancialAccount } from '@shared/models/form-instance';

interface CardType {
  url: string;
  altText: string;
}

@Component({
  selector: 'app-payment-card-info',
  templateUrl: './payment-card-info.component.html',
  styleUrls: ['./payment-card-info.component.scss'],
  standalone: true,
})
export class PaymentCardInfoComponent {
  @Input() paymentInfo?: FinancialAccount;
  @Output() selectedCard = new EventEmitter<string>();

  get cardDetails(): CardType {
    switch (this.paymentInfo?.brand) {
      case 'Visa':
        return {
          url: `/assets/cc_images/visa-sm.png`,
          altText: 'visa',
        };

      case 'Discover':
        return {
          url: `/assets/cc_images/discover-sm.png`,
          altText: 'discover',
        };

      case 'Master Card':
      default:
        return {
          url: `/assets/cc_images/mastercard-sm.png`,
          altText: 'mastercard',
        };
    }
  }

  get address(): string {
    const address = this.paymentInfo?.address;
    return address ? `, ${address.addressLine1}, ${address.city}, ${address.postalCode}, ${address.state}, ${address.country}` : '';
  }

  get expiryDateFormat(): string {
    const month = this.paymentInfo?.expiry?.split('-')[1];
    const year = this.paymentInfo?.expiry?.substring(2, 4);
    return `${month}/${year}`;
  }

  onCardSelect(): void {
    this.selectedCard.emit(this.paymentInfo?.faId);
  }
}
